/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAppointmentTypeRequestDto
 */
export interface UpdateAppointmentTypeRequestDto {
    /**
     * Appointment type name
     * @type {string}
     * @memberof UpdateAppointmentTypeRequestDto
     */
    name: string;
    /**
     * Appointment type color code
     * @type {string}
     * @memberof UpdateAppointmentTypeRequestDto
     */
    colorCode: string;
    /**
     * Appointment type duration in minutes
     * @type {number}
     * @memberof UpdateAppointmentTypeRequestDto
     */
    duration: number;
    /**
     * Appointment type ID
     * @type {string}
     * @memberof UpdateAppointmentTypeRequestDto
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateAppointmentTypeRequestDto interface.
 */
export function instanceOfUpdateAppointmentTypeRequestDto(value: object): value is UpdateAppointmentTypeRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('colorCode' in value) || value['colorCode'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateAppointmentTypeRequestDtoFromJSON(json: any): UpdateAppointmentTypeRequestDto {
    return UpdateAppointmentTypeRequestDtoFromJSONTyped(json, false);
}

export function UpdateAppointmentTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'colorCode': json['colorCode'],
        'duration': json['duration'],
        'id': json['id'],
    };
}

export function UpdateAppointmentTypeRequestDtoToJSON(json: any): UpdateAppointmentTypeRequestDto {
    return UpdateAppointmentTypeRequestDtoToJSONTyped(json, false);
}

export function UpdateAppointmentTypeRequestDtoToJSONTyped(value?: UpdateAppointmentTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'colorCode': value['colorCode'],
        'duration': value['duration'],
        'id': value['id'],
    };
}

